import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const StrategyBenchmarkChartToolbar = ({
  timeframe,
  timeframeOptions,
  onTimeframeChange,
  onFullscreenClick,
  fullscreenLabel,
  isRefetching = false
}) => (
  <div className="strategy-benchmark-chart__toolbar">
    <div className="strategy-benchmark-chart__timeframes">
      {isRefetching ? (
        <span
          className="strategy-benchmark-chart__timeframe-loader"
          aria-hidden="true"
        >
          <i className="fal fa-spinner fa-spin" />
        </span>
      ) : null}
      {timeframeOptions.map(option => (
        <button
          key={option.value}
          type="button"
          className={classNames("strategy-benchmark-chart__timeframe", {
            "strategy-benchmark-chart__timeframe--active":
              option.value === timeframe
          })}
          onClick={() => onTimeframeChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
    <button
      type="button"
      className="strategy-benchmark-chart__fullscreen"
      onClick={onFullscreenClick}
      aria-label={fullscreenLabel}
      title={fullscreenLabel}
    >
      <i className="fal fa-expand" aria-hidden="true" />
    </button>
  </div>
);

StrategyBenchmarkChartToolbar.propTypes = {
  timeframe: PropTypes.string.isRequired,
  timeframeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  onTimeframeChange: PropTypes.func.isRequired,
  onFullscreenClick: PropTypes.func.isRequired,
  fullscreenLabel: PropTypes.string.isRequired,
  isRefetching: PropTypes.bool
};

export default StrategyBenchmarkChartToolbar;
